export { default } from './ReviewPaginationButton';